import Vue from 'vue'
/**
 */

export default () =>
  Vue.$http.get(`users/treatments/`)
    .then(response => response.data)
